import Vue from 'vue';
import Vuex from 'vuex';
import stringUtils from '@/utils/stringUtils';

Vue.use(Vuex);

import Config from '@/config.js';

export default new Vuex.Store({
	state: {
		estruturaCamadas: null,
		camadas: null,
		camadasAtivas: null,
		camadasOrdenadas: null,
		idCamadasUsuario: 1,
		grupoCamadasUsuario: null,
		mapa: {
			zoom: Config.zoom,
			minZoom: 5,
			maxZoom: 17,
			coordinate: null,
			baseMapa: null
		}
	},

	mutations: {

		setMapZoom (state, value) {
			state.mapa.zoom = value;
		},
		
		setMinZoom (state, value) {
			state.mapa.minZoom = value;
		},
		
		setMaxZoom (state, value) {
			state.mapa.maxZoom = value;
		},

		setBaseMap (state, value) {
			state.mapa.baseMapa = value;
		},

		setEstruturaCamadas (state, value) {

			state.estruturaCamadas = value || { grupos: [] };
			state.camadas = {};
			state.camadasAtivas = [];
			var camadasOrdenadas = [];

			eachCamada(state.estruturaCamadas, (c, grupo) => {

				c.grupoPai = grupo;
				state.camadas[c.id] = c;
				camadasOrdenadas.push(c);
				if (c.habilitado) state.camadasAtivas.push(c);
			});
			
			state.camadasOrdenadas = _.orderBy(camadasOrdenadas,
				[c => stringUtils.latinize(c.nome).toLowerCase()], ['asc']);
		},

		ativarCamada (state, camada) {
			
			if (camada.habilitado) return;
			camada.habilitado = true;
			state.camadasAtivas = _.concat(state.camadasAtivas, camada);
		},

		desativarCamada (state, camada) {
			
			if (!camada.habilitado) return;
			camada.habilitado = false;
			
			state.camadasAtivas = removerCamada(state.camadasAtivas, camada);
		},

		moverCamadaAtiva (state, options) {
			
			let currentIndex = _.findIndex(state.camadasAtivas, ['id', options.camada.id]);

			if (currentIndex < 0) return;
			
			let newList = removerCamada(state.camadasAtivas, options.camada);

			newList.splice(options.index, 0, options.camada);
			state.camadasAtivas = newList;
		},
		
		setCoordinate (state, coordinate) {

			state.mapa.coordinate = coordinate;
		},

		adicionarCamadaUsuario (state, camada) {

			state.idCamadasUsuario++;
			camada.id = 'user' + state.idCamadasUsuario;
			camada.camadaUsuario = true;
			camada.habilitado = false;
			state.camadas[camada.id] = camada;

			if (!state.grupoCamadasUsuario) {
				
				state.grupoCamadasUsuario = {
					nome: 'Minhas camadas',
					cssClass: 'grupo-camadas-usuario',
					camadas: []
				};
				
				state.estruturaCamadas.grupos.splice(0, 0, state.grupoCamadasUsuario);
			}
			
			state.grupoCamadasUsuario.camadas.push(camada);
		}
	},

	getters: {
		mapaZoom: (state) => {
			return (state) => state.mapa.zoom;
		},

		getCamada: (state) => (id) => {
			return state.camadas[id];
		},

		camadasAtivasSig: (state) => {
			return _.filter(state.camadasAtivas, (c) => !c.camadaUsuario);
		}
	}
});

function removerCamada (camadas, camada) {

	return _.filter(camadas, (c) => {
		return c !== camada && c.id !== camada.id;
	});
}

function eachCamada (grupo, fn) {
	
	if (grupo.camadas) {
		for (let camada of grupo.camadas) {
			fn(camada, grupo);
		}
	}

	if (grupo.grupos) {
		for (let subGrupo of grupo.grupos) {
			eachCamada(subGrupo, fn);
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/index.js